import { gql } from '@apollo/client';

const ASSIGN_APPRAISER = gql`
  mutation assignAppraiser($user: AssignUserLicenseInput!, $appraiser: AppraiserInput!) {
    assignAppraiser(user: $user, appraiser: $appraiser) {
      Success
      Message
    }
  }
`;

export default ASSIGN_APPRAISER;
